import React from 'react';

import {Link} from 'react-router';

import {useComments} from 'app/comments/api';
import {CommentItem} from 'app/comments/components/CommentItem';
import {gt} from 'app/utils/i18n';

import {DashboardListWidget} from './DashboardListWidget';

export function RecentCommentsWidget() {
  return (
    <DashboardListWidget
      icon="far fa-comments"
      title={gt('Recent Comments')}
      hook={useComments}
      params={{page_size: 5}}
      emptyMessage={gt('No Recent Comments')}
      renderItem={(comment) => (
        <CommentItem comment={comment} canDelete={false} isTarget={false}>
          <p className="font-italic mb-2 small font-weight-light">
            {gt(
              'Commented on %s',
              <Link to={comment.html_url}>{comment.name}</Link>
            )}
          </p>
        </CommentItem>
      )}
    />
  );
}
